export default __webpack_public_path__ + "static/media/Show-documentation.5c64ca52.md";